module.exports = __webpack_public_path__ + "img/1-2.a48af965.jpg";